import React from 'react'
import PropTypes from 'prop-types'
import { Alert, Space } from 'antd'
import { decisionQuestion, expiresIn } from '../decisions'
import { serviceTag } from '../statusColors'

// The assistant is waiting on the customer to answer a car question (spec:
// 0040_assistant_car_decisions Req 2). Shown above the transcript so whoever opens the
// conversation knows the next message is an answer to it, not a fresh request.
const DecisionBanner = ({ decision }) => {
  if (!decision) return null
  const question = decisionQuestion(decision.kind)
  const opened = decision.openedAt ? new Date(decision.openedAt).toLocaleTimeString() : ''
  const expiry = expiresIn(decision.expiresAt)
  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 12 }}
      message={
        <Space wrap>
          <span>
            Waiting for the customer: <strong>{question}</strong>
            {decision.carLabel ? ` — ${decision.carLabel}` : ''}
          </span>
          {decision.target ? serviceTag(decision.target) : null}
        </Space>
      }
      description={[opened ? `Asked at ${opened}` : '', expiry].filter(Boolean).join(' · ')}
    />
  )
}

DecisionBanner.propTypes = {
  decision: PropTypes.shape({
    kind: PropTypes.string,
    target: PropTypes.string,
    carLabel: PropTypes.string,
    openedAt: PropTypes.string,
    expiresAt: PropTypes.string,
    misses: PropTypes.number
  })
}

DecisionBanner.defaultProps = { decision: null }

export default DecisionBanner
